<template>
  <div>
    <v-stepper-step :complete="step > stepConfig" step="!">
      Selecione o tipo de atestado/documento 
      <v-chip v-if="atestadoEnviar.tipo > 0 && step > stepConfig" small>{{
        getTipoSelecionado().descricao
      }}</v-chip>
    </v-stepper-step>
    <v-stepper-content :step="stepConfig">
      <v-card flat class="mt-2">
        <v-card-text class="pt-0 pb-0">
          <v-alert v-if="getTiposAtestado().length == 0" type="info" text>
            Nenhum tipo de documento disponível
          </v-alert>
          <v-radio-group v-model="atestadoEnviar.tipo" v-else>
            <v-radio
              v-for="(tipo, i) in getTiposAtestado()"
              :key="i"
              :label="tipo.descricao"
              class="pb-2"
              :value="tipo.codigo"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-btn
            rounded
            small
            color="info"
            @click="continuar()"
            v-if="getTiposAtestado().length > 0"
            >Continuar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  computed: mapState("atestado", [
    "atestadoEnviar",
    "configs",
    "step",
    "atestSelec",
    "screens",
  ]),
  data: () => ({
    stepConfig: 10,
  }),
  methods: {
    ...mapMutations("atestado", ["setNextStep", "setScreens"]),
    ...mapGetters("atestado", ["getTipoSelecionado"]),
    getTiposAtestado() {
      if (this.atestSelec)
        return this.configs.filter(
          (config) => config.codigo == this.atestSelec.codconfigatest
        );

      return this.configs;
      //return this.configs.filter((config) => config.codcategoria == 5);
    },
    continuar() {
      this.setNextStep();
      this.setScreens(
        this.configs.find((config) => config.codigo == this.atestadoEnviar.tipo)
      );
    },
  },
  mounted() {
    if (this.getTiposAtestado().length > 0)
      this.atestadoEnviar.tipo = this.getTiposAtestado()[0].codigo;
  },
};
</script>

<style>
</style>